export const flowPath = "/flow";

export default flowPath;
